export default "__VITE_ASSET__ODRHe0p9__"